import React from "react";
//#region types
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion
//#region components
import SendToDebtCollectionFormContainer from "./sendToDebtCollectionFormContainer";
//#endregion

function useSendToDebtCollectionDialog(onSendSuccess?: (value?: any) => void) {
  const getDebtCollectionDialog = (invoiceId: number): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SendToDebtCollectionDialogTitle),
      titleIcon: IconDefinitionConstants.WQuestionCircle,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Complete),
          successMessage: TranslationKeys.Invoice.SendToDebtCollectionSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <SendToDebtCollectionFormContainer invoiceId={invoiceId} />,
      maxWidth: "sm",
      onSubmit: onSendSuccess,
    };
  };

  return getDebtCollectionDialog;
}

export default useSendToDebtCollectionDialog;
